module.exports = __webpack_public_path__ + "img/example_2.b5a24db7.png";